import { createElement } from 'react';
import './index.scss';
const Button = ({ name, color, ...otherProps }) => {
    return (createElement("span", { className: 'button__container', style: { color: color }, ...otherProps }, name));
};
export default Button;
